(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohw-product-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.ohw-video--passive').forEach(video => {
      if (video.dataset.ohwPassiveReady) return;
      video.dataset.ohwPassiveReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.loop = true;
      const fit = () => {
        if (!video.videoWidth || !video.videoHeight) return;
        const wrap = video.closest('.ohw-video-wrap');
        if (!wrap) return;
        wrap.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
        wrap.style.maxWidth = video.videoHeight > video.videoWidth ? '240px' : '480px';
        video.width = video.videoWidth;
        video.height = video.videoHeight;
      };
      video.addEventListener('loadedmetadata', fit);
      fit();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting && !document.hidden) video.play().catch(() => {});
          else video.pause();
        }), {threshold: .15});
        observer.observe(video);
      } else {
        video.play().catch(() => {});
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('.ohw-video--passive').forEach(video => {
      const rect = video.getBoundingClientRect();
      if (document.hidden) video.pause();
      else if (rect.bottom > 0 && rect.top < innerHeight) video.play().catch(() => {});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohw-toe-video-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ohw-toe-videos]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('.ohw-toe-videos__track');
      const cards = [...track.children];
      const previous = root.querySelector('[data-ohw-video-prev]');
      const next = root.querySelector('[data-ohw-video-next]');
      const position = root.querySelector('[data-ohw-video-position]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const index = Math.min(cards.length - 1, Math.round(track.scrollLeft / step));
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        position.textContent = `${index + 1} / ${cards.length}`;
      };
      const move = direction => {
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left: direction * step, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(update).observe(track);
      const videos = [...root.querySelectorAll('video')];
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && !document.hidden) video.play().catch(() => {});
        else video.pause();
      }), {threshold:.01});
      videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.controls = false;
        video.loop = true;
        video.removeAttribute('controls');
        observer.observe(video);
      });
      document.addEventListener('visibilitychange', () => {
        videos.forEach(video => {
          if (document.hidden) video.pause();
          else {observer.unobserve(video); observer.observe(video);}
        });
      });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
